// extracted by mini-css-extract-plugin
export default {"gridItem":"gridItem-ef97","isOpen":"isOpen-a540","cardInner":"cardInner-71fe","cardFront":"cardFront-e815","cardBack":"cardBack-cc17"};